import { render, staticRenderFns } from "./UnsavedChangesDialog.vue?vue&type=template&id=280f6a2e"
import script from "./UnsavedChangesDialog.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports